<template>
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" :class="className">
    <path d="M22 10v6" />
    <path d="M6 12l6 3 10-5-10-5-10 5 4 2" />
    <path d="M6 12v5c0 1 3 3 6 3s6-2 6-3v-5" />
  </svg>
</template>

<script>
export default {
  name: 'IconGraduationCap',
  props: { className: { type: String, default: 'w-5 h-5' } },
}
</script>

